<template>
    <v-container >
      <v-layout align-start justify-center row>
        <v-flex class="text-md-center">
          <span class="display-2">401 UNAUTHORIZED</span>
        </v-flex>
      </v-layout>
      <v-layout align-start justify-center row>
        <v-flex class="text-md-center">
          <span>The request has not been applied because it lacks valid authentication credentials for the target resource.</span>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
export default {
    data () {
        return {
        }
    }
}
</script>
<style>
</style>
